// src/components/SingleProduct/SpecialDetails.jsx
import { Link } from 'react-router-dom';

const SpecialDetails = ({ specialData, allSpecials = [], menuSlug }) => {
    const hasMultipleSpecials = allSpecials.length > 1;

    return (
        <div className='headless-product-special-details'>
            <div className='headless-product-special'>
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    height='1em'
                    viewBox='0 0 512 512'
                >
                    <path d='M204.1 32c12.7 0 24.9 5.1 33.9 14.1L410.7 218.7c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0L14.1 270.1c-9-9-14.1-21.2-14.1-33.9V80C0 53.5 21.5 32 48 32H204.1zM36.7 247.4L209.4 420.1c12.5 12.5 32.8 12.5 45.3 0L388.1 286.6c12.5-12.5 12.5-32.8 0-45.3L215.4 68.7c-3-3-7.1-4.7-11.3-4.7H48c-8.8 0-16 7.2-16 16V236.1c0 4.2 1.7 8.3 4.7 11.3zM308.4 36.9c6.1-6.4 16.2-6.6 22.6-.5l141.3 135c52.8 50.4 52.8 134.7 0 185.1l-124.6 119c-6.4 6.1-16.5 5.9-22.6-.5s-5.9-16.5 .5-22.6l124.6-119c39.6-37.8 39.6-101 0-138.8L308.9 59.6c-6.4-6.1-6.6-16.2-.5-22.6zM104 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48z' />
                </svg>
                <span>
                    {hasMultipleSpecials 
                        ? 'This product is currently on multiple specials' 
                        : 'This product is currently on special'
                    }
                </span>
            </div>
            
            {hasMultipleSpecials ? (
                <div className='headless-product-special-details-list'>
                    <div className='headless-special-items'>
                        {allSpecials.map((special, index) => (
                            <div key={special.id || index} className='headless-special-item'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    height='1em'
                                    viewBox='0 0 512 512'
                                    className='headless-special-item-icon'
                                >
                                    <path d='M204.1 32c12.7 0 24.9 5.1 33.9 14.1L410.7 218.7c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0L14.1 270.1c-9-9-14.1-21.2-14.1-33.9V80C0 53.5 21.5 32 48 32H204.1zM36.7 247.4L209.4 420.1c12.5 12.5 32.8 12.5 45.3 0L388.1 286.6c12.5-12.5 12.5-32.8 0-45.3L215.4 68.7c-3-3-7.1-4.7-11.3-4.7H48c-8.8 0-16 7.2-16 16V236.1c0 4.2 1.7 8.3 4.7 11.3zM308.4 36.9c6.1-6.4 16.2-6.6 22.6-.5l141.3 135c52.8 50.4 52.8 134.7 0 185.1l-124.6 119c-6.4 6.1-16.5 5.9-22.6-.5s-5.9-16.5 .5-22.6l124.6-119c39.6-37.8 39.6-101 0-138.8L308.9 59.6c-6.4-6.1-6.6-16.2-.5-22.6zM104 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48z' />
                                </svg>
                                {menuSlug && special.id ? (
                                    <Link 
                                        to={`/shop/${menuSlug}/special/${special.id}/`}
                                        className='headless-special-link'
                                        reloadDocument
                                    >
                                        {special.name}
                                    </Link>
                                ) : (
                                    <span>{special.name}</span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            ) : specialData?.name ? (
                <div className='headless-product-special-details-name'>
                    <strong>Special Details:</strong> {' '}
                    {menuSlug && specialData.id ? (
                        <Link 
                            to={`/shop/${menuSlug}/special/${specialData.id}/`}
                            className='headless-special-link'
                            reloadDocument
                        >
                            {specialData.name}
                        </Link>
                    ) : (
                        <span>{specialData.name}</span>
                    )}
                </div>
            ) : null}
        </div>
    );
};

export default SpecialDetails;
